import React from "react";
import cn from "classnames";

interface CollectionClassificationFilterProps {
    classificationsKeyValues;
    selectedClassification: string;
    handleClassificationChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CollectionClassificationFilter = ({
    classificationsKeyValues,
    selectedClassification,
    handleClassificationChange,
}: CollectionClassificationFilterProps) => {
    return (
        <div className="CollectionFilter__classifications" role="radiogroup" aria-label="Filter Options">
            {classificationsKeyValues.map((object) => (
                <label
                    className={cn("CollectionFilter__classification-button", {
                        "CollectionFilter__classification-button--selected": selectedClassification === object.key,
                    })}
                    key={object.key}
                >
                    <input
                        type="radio"
                        name="classification"
                        value={object.key}
                        checked={selectedClassification === object.key}
                        onChange={handleClassificationChange}
                        className="CollectionFilter__radio-input"
                    />
                    {object.value}
                </label>
            ))}
        </div>
    );
};
